<template>
  <div class="makler-activation-page-container">
    <v-container class="makler-activation-page pa-0" fluid>
      <div class="primary--text semanticsection-title2">
        Makleraktivierung/Initialkennwort-Vergabe
      </div>
      <v-row no-gutters>
        <v-text-field v-model="Vermittlernummer"
                      v-validate="{required: true, digits: 5}"
                      :error-messages="errors.collect('Vermittlernummer')"
                      :loading="isLoading"
                      data-vv-as="Vermittlernummer"
                      data-vv-validate-on="blur"
                      class="input-vermittlernummer mr-3"
                      mask="#####"
                      append-icon="search"
                      clearable
                      hint="5-stellige Vermittlernummer"
                      name="Vermittlernummer"
                      label="Vermittlernummer"
                      @keyup.enter="loadAntrag(Vermittlernummer)"
                      @input="errors.remove('Vermittlernummer')" />
        <v-btn color="primary"
               @click="loadAntrag(Vermittlernummer)">
          Prüfen/Aktivieren
        </v-btn>
      </v-row>
      <div v-if="loadingErrorMessage"
           class="error--text mb-4">
        {{ loadingErrorMessage }}
      </div>
      <div v-if="resultItems !== null" class="details-table">
        <v-data-table
                  v-if="isSucces" 
                  :items="resultItems"
                  hide-default-header
                  hide-default-footer
                  class="no--hover">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.label }}</td>
              <td v-if="item.label === 'Status'"
                    class="value-data-cell">
                    {{ item.value }}
                </td>
                <td v-else
                    class="value-data-cell">{{ item.value }}
                </td>
              </tr>
          </template>
        </v-data-table>
        <template v-if="makeVisible">
          <div class="dmb-form-text mt-3">Zusatzaktion für aktivierten Makler:</div>
          <v-text-field v-model="processingInfo"
                        v-validate="{required: true}"
                        :error-messages="errors.collect('Bearbeitungshinweis')"
                        :loading="isSending"
                        clearable
                        name="Bearbeitungshinweis"
                        label="Bearbeitungshinweis" />
          <v-btn color="primary"
                @click="resendAntrag()">
            Zusatzaktion ausführen
          </v-btn>

          <div :class=" resendFailed ? 'error--text' : 'success--text'"
              class="dmb-form-text mt-2"> {{ resendResultMessage }}
          </div>
        </template>
        <div class="semanticsection-title primary--text">Protokoll:</div>
        <div v-for="(value, key) in interfaceData"
             :key="key">
          {{ key }}: {{ value }}
        </div>

      </div>

    </v-container>
  </div>
</template>

<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import httpService from "@/helper/httpService";

export default {
  name: "MaklerActivationPage",
  mixins: [ValidationMixin],
  data() {
    return {
      makeVisible: false,
      Vermittlernummer: null,
      isLoading: false,
      loadingErrorMessage: "",
      queryResult: null,
      isSending: false,
      resendFailed: false,
      resendResultMessage: "",
      processingInfo: "",
      isSucces: false
    };
  },
  computed: {
    resultItems() {
      if (this.queryResult === null) {
        return null;
      } else {
        return this.formatAntragToLableValueItems(this.queryResult);
      }
    },
    // isSucces() {
    //    if( this.resultItems){
    //      if(this.resultItems.status){
    //        if(this.resultItems.status === 'success'){
    //          return true;
    //        }
    //      }
    //    }
    //    return false;
    // },
    interfaceData() {
      const interfaceData = { ...this.queryResult };
      delete interfaceData.attachments;
      return interfaceData;
    }
  },
  methods: {
    loadAntrag(vmnr) {
      this.queryResult = null;
      this.isSucces = false;
      this.loadingErrorMessage = null;
      this.$validator.validate("Vermittlernummer").then((result) => {
        if (result) {
          this.isLoading = true;
          httpService.initVermittlernummer(vmnr)
            .then(result => {
              this.queryResult = result;
              this.loadingErrorMessage = null;
              this.resendFailed = false;
              this.resendResultMessage = "";
              this.isLoading = false;
              this.isSucces = result.status == 'success';
              this.loadingErrorMessage = result.status != 'success' ? `${result.message}` : '';
            })
            .catch(error => {
              if (error.status === 404) {
                this.loadingErrorMessage = `Vermittlernummer ${vmnr} nicht gefunden.`;
              } else {
                const errorBodyText = error.body ? ` (${JSON.stringify(error.body)})` : "";
                this.loadingErrorMessage = `${error}${errorBodyText}`;
              }
              this.queryResult = null;
              this.isLoading = false;
            });
        }
      });
    },
    formatAntragToLableValueItems(antrag) {
      let parsedData = {
        status: antrag.status == 'success' ? antrag.message : antrag.status,
        vermittlernummer: antrag.vmnr,
        loginname: antrag.makler ? antrag.makler.username : '',
        initialkennwort: antrag.initialkennwort,
        vermittler: antrag.makler
      };

      return [
        {
          label: "Vermittlernummer",
          value: parsedData.vermittlernummer
        },
        {
          label: "Status",
          value: parsedData.status
        },
        {
          label: "Initialkennwort",
          value: parsedData.initialkennwort
        },
        {
          label: "Loginname",
          value: parsedData.loginname
        }
      ];
    },
    resendAntrag() {
      this.$validator.validate("Bearbeitungshinweis").then((result) => {
        if (result) {
          this.isSending = true;
          this.resendFailed = false;
          const toSend = { ...this.queryResult, processinginfo: this.processingInfo };
          httpService.resendAntrag(toSend)
            .then(() => {
              this.isSending = false;
              this.resendResultMessage = "Antrag wurde erfolgreich übermittelt.";
            })
            .catch(() => {
              this.isSending = false;
              this.resendFailed = true;
              this.resendResultMessage = "Fehler beim Senden! Sie müssen den Administrator des Maklerportals kontaktieren, um diesen Antrag erneut zu senden.";
            });
        }
      });

    }
  }
};
</script>

<style>
.makler-activation-page-container {
  margin: 0 48px 100px 48px;
  display: flex;
  justify-content: center;
}

.makler-activation-page {
  max-width: 768px;
  width: 768px;
}

.makler-activation-page .input-vermittlernummer {
  max-width: 260px;
}
.makler-activation-page .details-table .v-data-table  {
  margin-left: 0px;
}
</style>
